import type { FaireProductEntity } from "../../entity_types/product";

export const p_nx22yk8j72: FaireProductEntity = {
  token: "p_nx22yk8j72",
  type: "product",
  name: "Partners Cold Brew Concentrate 32oz. - Case of 4 Units",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/cbef6bcb437591a391c8511b37dc610f0c8b1ce14b34d1901c1507a2a6f7994b.png",
  galleryImageUrls: [],
  priceDollars: 253.8,
  description: "The cold brew you know and love – now available as a convenient 32 oz shelf-stable concentrate that can be shipped alongside your regular coffee orders. More concentrated with notes of vanilla, toffee, and fudge pop, you’ll enjoy incredible taste alongside the practicality of ambient storage.\n\nOur Shelf-Stable Cold Brew Concentrate includes 40 x 8oz servings of cafe-quality cold brew with notes of vanilla, toffee, and fudge pop.\n\nSimply mix one bottle of our 32oz Cold Brew Concentrate with 2.25 Gallons of water for a batch of ready-to-drink cold brew!\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 340,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:07.284Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
